export const getFormworkFile_api = {
	url: 'getFormworkFile',
	method: 'get',
	title: '模板文件列表'
}

export const upload_api = {
	url: 'uploadBySurvey',
	method: 'post',
	title: '导入'
}



// WEBPACK FOOTER //
// ./src/views/base/memberquesrgath/importDialog/desc.js